<!-- blog -->
<div class="section section-blog bg-white container-fluid bg-white">

  <a class="section-anchor" name="section-blog"></a>

  <h2 class="alternate-heading text-center">
    {{'Our latest' | translate}} <span class="text-primary">{{'news' | translate}}</span>
  </h2>

  <div class="slider-blog">

    <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="blogarticles">
      <ng-template *ngFor="let slide of blogarticles" ngbSlide>

        <div class="row">
          <div class="col-12 col-md-4 col" *ngFor="let slideItem of slide">
            <a class="blog-link cursor-pointer" [routerLink]="'blog/' + slideItem.id">
              <div class="img-wrapper" *ngIf="slideItem.imageUri" [ngStyle]="{'background-image' : 'url(' + slideItem.imageUri + ')'}"></div>
              <div class="blog-caption">
                <div class="blog-content-wrapper shadow">
                  <h3 class="title" *ngIf="slideItem.title">{{externalpageService.getTranslatedTitle(slideItem).length > 20 ? (externalpageService.getTranslatedTitle(slideItem) | slice:0:20) + '...' : externalpageService.getTranslatedTitle(slideItem) }}</h3>
                </div>

              </div>
            </a>

          </div>
        </div>
      </ng-template>
    </ngb-carousel>

  </div>

  <div class="row row-button-more">

    <div class="col-12 col-sm-12 text-center">
      <a routerLink="/blog" class="btn btn-primary btn-special">
        {{'All messages' | translate}}
      </a>
    </div>

  </div>

</div>
